/* G&G Author Submit JS. Two-column form with custom dropdowns (single +
   multiselect), license pricing, tag pills, SEO counters, and product
   metafields rendered from the shop's definitions/options.
   POST multipart -> /apps/proxy/api/storefront/authors/submissions */
(function () {
  'use strict';
  // The version prints on every page load. "Is the new file actually live?" is
// otherwise a guess, and it was a wrong guess twice: the theme was serving a
// build from between two of these changes.
try { console.log('[asub] author-submit.js v2026-08-28-r6 (per-type prices, alt text, type-scoped details)'); } catch (e) {}

  var MAX_FILES = 8;
  // Per-zone limits (server streams sale files to B2, buffers previews).
  var PREVIEW_MAX = 30 * 1024 * 1024;            // preview images
  var SALE_MAX = 2 * 1024 * 1024 * 1024;         // sale/deliverable source files
  var MODEL_MAX = 100 * 1024 * 1024;             // 3D viewer model (.glb)
  var IMG_RE = /^image\//i;
  var GLB_RE = /\.(glb|gltf)$/i;
  var TAGS_COLLAPSE_AT = 6;

  function el(tag, opts) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.className) n.className = opts.className;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
    }
    return n;
  }
  function ext(name) { var m = /\.([a-z0-9]+)$/i.exec(name || ''); return m ? m[1] : 'file'; }

  // POST a multipart body via XHR so we can report upload progress (fetch can't).
  function xhrUpload(url, formData, onProgress) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      if (xhr.upload && onProgress) {
        xhr.upload.addEventListener('progress', function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); });
      }
      xhr.addEventListener('load', function () {
        var json = null; try { json = JSON.parse(xhr.responseText); } catch (e) {}
        resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status, json: json || {} });
      });
      xhr.addEventListener('error', function () { reject(new Error('Network error')); });
      xhr.addEventListener('timeout', function () { reject(new Error('Request timed out')); });
      xhr.send(formData);
    });
  }

  // Wrap a number input with custom up/down steppers (native spinners hidden
  // via CSS). Keeps the field styled consistently with the rest of the form.
  function enhanceNumber(input) {
    if (!input || input.dataset.stepped) return;
    input.dataset.stepped = '1';
    var wrap = el('span', { className: 'asub-num' });
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);
    var steps = el('span', { className: 'asub-num-steps' });
    function mk(dir) {
      var b = el('button', { className: 'asub-num-step asub-num-' + (dir > 0 ? 'up' : 'down'), attrs: { type: 'button', tabindex: '-1', 'aria-label': dir > 0 ? 'Increase' : 'Decrease' } });
      b.addEventListener('click', function (e) {
        e.preventDefault();
        try { if (dir > 0) input.stepUp(); else input.stepDown(); } catch (err) { input.value = (parseFloat(input.value) || 0) + dir; }
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return b;
    }
    steps.appendChild(mk(1)); steps.appendChild(mk(-1));
    wrap.appendChild(steps);
  }

  // Close any open custom-select when clicking elsewhere.
  var openPanels = [];
  document.addEventListener('click', function (e) {
    openPanels.forEach(function (cs) { if (!cs.root.contains(e.target)) cs.close(); });
  });

  /* Reusable custom dropdown. opts: { options:[{value,label}], value, multiple,
     placeholder, searchable, onChange }. Returns { root, getValue, setValue }. */
  function customSelect(opts) {
    var options = opts.options || [];
    var multiple = !!opts.multiple;
    var selected = multiple ? (Array.isArray(opts.value) ? opts.value.slice() : []) : (opts.value || '');
    var searchable = opts.searchable != null ? opts.searchable : options.length > 7;

    var root = el('div', { className: 'asub-cs' });
    var toggle = el('button', { className: 'asub-cs-toggle', attrs: { type: 'button', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' } });
    var label = el('span', { className: 'asub-cs-label' });
    var chevron = el('span', { className: 'asub-cs-chevron', attrs: { 'aria-hidden': 'true' } });
    toggle.appendChild(label); toggle.appendChild(chevron);
    var panel = el('div', { className: 'asub-cs-panel', attrs: { role: 'listbox' } });
    panel.hidden = true;
    var search = null, list = el('div', { className: 'asub-cs-list' });
    if (searchable) {
      search = el('input', { className: 'asub-cs-search', attrs: { type: 'text', placeholder: 'Search...' } });
      panel.appendChild(search);
      search.addEventListener('input', function () { renderList(search.value.toLowerCase()); });
      search.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    panel.appendChild(list);
    root.appendChild(toggle); root.appendChild(panel);

    function labelFor(v) { for (var i = 0; i < options.length; i++) if (options[i].value === v) return options[i].label; return v; }
    function syncLabel() {
      if (multiple) {
        if (!selected.length) { label.textContent = opts.placeholder || 'Select'; label.classList.add('is-placeholder'); }
        else { label.textContent = selected.length <= 2 ? selected.map(labelFor).join(', ') : (selected.length + ' selected'); label.classList.remove('is-placeholder'); }
      } else {
        if (!selected) { label.textContent = opts.placeholder || 'Select'; label.classList.add('is-placeholder'); }
        else { label.textContent = labelFor(selected); label.classList.remove('is-placeholder'); }
      }
    }
    function renderList(filter) {
      list.innerHTML = '';
      var any = false;
      options.forEach(function (o) {
        if (filter && o.label.toLowerCase().indexOf(filter) === -1) return;
        any = true;
        var isSel = multiple ? selected.indexOf(o.value) !== -1 : selected === o.value;
        var item = el('div', { className: 'asub-cs-option' + (isSel ? ' is-selected' : ''), attrs: { role: 'option', tabindex: '-1', 'aria-selected': isSel ? 'true' : 'false' } });
        if (multiple) { var box = el('span', { className: 'asub-cs-check' }); item.appendChild(box); }
        item.appendChild(el('span', { text: o.label }));
        item.addEventListener('click', function (e) {
          e.stopPropagation();
          if (multiple) {
            var idx = selected.indexOf(o.value);
            if (idx === -1) selected.push(o.value); else selected.splice(idx, 1);
            renderList(filter || ''); syncLabel();
            if (opts.onChange) opts.onChange(selected);
          } else {
            selected = o.value; syncLabel(); close(); toggle.focus();
            if (opts.onChange) opts.onChange(selected);
          }
        });
        list.appendChild(item);
      });
      if (!any) list.appendChild(el('div', { className: 'asub-cs-empty', text: 'No matches' }));
    }
    function optionEls() { return Array.prototype.slice.call(list.querySelectorAll('.asub-cs-option')); }
    function focusOption(idx) { var o = optionEls(); if (!o.length) return; idx = Math.max(0, Math.min(idx, o.length - 1)); o[idx].focus(); }
    function moveFocus(delta) {
      var o = optionEls(); if (!o.length) return;
      var cur = o.indexOf(document.activeElement);
      focusOption(cur === -1 ? (delta > 0 ? 0 : o.length - 1) : cur + delta);
    }
    function open() { panel.hidden = false; root.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); openPanels.push(api); if (search) { search.value = ''; renderList(''); setTimeout(function () { search.focus(); }, 0); } else { setTimeout(function () { focusOption(0); }, 0); } }
    function close() { panel.hidden = true; root.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); var i = openPanels.indexOf(api); if (i !== -1) openPanels.splice(i, 1); }
    toggle.addEventListener('click', function (e) { e.stopPropagation(); if (panel.hidden) open(); else close(); });
    // Keyboard: open with Down/Up; navigate options; Enter/Space select; Esc close.
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); if (panel.hidden) open(); else moveFocus(e.key === 'ArrowUp' ? -1 : 1); }
      else if (e.key === 'Escape') { if (!panel.hidden) close(); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveFocus(-1); }
      else if (e.key === 'Home') { e.preventDefault(); focusOption(0); }
      else if (e.key === 'End') { e.preventDefault(); focusOption(optionEls().length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); var a = document.activeElement; if (a && a.classList.contains('asub-cs-option')) a.click(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); toggle.focus(); }
      else if (e.key === 'Tab') { close(); }
    });
    if (search) {
      search.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); focusOption(0); }
        else if (e.key === 'Escape') { e.preventDefault(); close(); toggle.focus(); }
        else if (e.key === 'Enter') { e.preventDefault(); var first = optionEls()[0]; if (first) first.click(); }
      });
    }

    var api = {
      root: root, close: close,
      getValue: function () { return multiple ? selected.slice() : selected; },
      setValue: function (v) { selected = multiple ? (v || []) : (v || ''); syncLabel(); },
      // Swap the list without rebuilding the widget. A selection that the new
      // list no longer offers is dropped rather than left behind invisibly.
      setOptions: function (next) {
        options = next || [];
        if (multiple) selected = selected.filter(function (v) { return options.some(function (o) { return o.value === v; }); });
        else if (selected && !options.some(function (o) { return o.value === selected; })) selected = '';
        renderList(''); syncLabel();
      },
    };
    renderList(''); syncLabel();
    if (opts.host) opts.host.appendChild(root);
    return api;
  }

  function init(root) {
    var inner = root.querySelector('.asub-inner');
    if (!inner) return;
    var isPreview = root.dataset.asubPreview === '1';
    if (!isPreview && inner.getAttribute('data-asub-is-author') !== '1') return;

    var currency = inner.getAttribute('data-asub-currency') || 'USD';
    var currencySymbol = inner.getAttribute('data-asub-currency-symbol') || '$';
    var licenseOptionName = inner.getAttribute('data-asub-license-option-name') || 'License';
    var freeVariantName = inner.getAttribute('data-asub-free-variant') || 'Free';

    // Edit mode: same form, but prefilled from an existing submission and
    // POSTed to the single-submission endpoint (product -> DRAFT, re-moderation).
    var isEdit = (inner.getAttribute('data-asub-mode') || 'create') === 'edit';
    var editId = '';
    if (isEdit) {
      try {
        var qs = new URLSearchParams(window.location.search);
        // `id` is what the Projects list appends. The other two are read as a
        // courtesy: a link pasted by hand, or an address that arrived with its
        // query in the hash, should still open the right project rather than a
        // blank form that only complains once it has been filled in.
        editId = qs.get('id') || qs.get('submissionId') || '';
        if (!editId && window.location.hash.indexOf('=') > -1) {
          editId = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('id') || '';
        }
      } catch (e) {}
    }
    // Two different mistakes lead here, and the message has to cover both:
    // the page was opened without a project, or this page is carrying the EDIT
    // section when it was meant to carry the submit one. The old wording only
    // mentioned the first, which is no help at all in the second case.
    var NO_ID_MSG = 'This page edits an existing project, and no project was given. '
      + 'Open it from the Edit button on one of your projects. '
      + 'If you meant to publish something new, this page is set up as the edit page by mistake.';
    var CREATE_URL = '/apps/proxy/api/storefront/authors/submissions';
    var EDIT_URL = '/apps/proxy/api/storefront/authors/submission';
    var SUBMIT_URL = isEdit ? EDIT_URL : CREATE_URL;
    // Pre-upload: each dropped file streams to B2 here (with progress) BEFORE
    // submit, so big sale files upload in the background and submit just sends
    // the resulting ids. Download lets the author grab back what they uploaded.
    var UPLOAD_URL = '/apps/proxy/api/storefront/authors/upload';
    var DOWNLOAD_URL = '/apps/proxy/api/storefront/authors/download';
    var CONFIG_URL = '/apps/proxy/api/storefront/authors/config';
    // Types that get the "Use standard pricing" checkbox (single mockups).
    // Which types have a standard price list is answered by the shop, not by
    // this line. It used to read ['mockups'], which is why the checkbox never
    // appeared for 3D however the prices were configured.
    var standardPricesByType = {};
    // Set after metafields finish rendering (async), so edit prefill can fill them.
    var afterMetafields = null;

    // Unsaved-changes guard (edit mode only). Listeners are attached AFTER the
    // prefill so programmatic fills don't mark the form dirty.
    var dirty = false;
    function markDirty() { dirty = true; }
    function beforeUnloadHandler(e) { if (dirty && isEdit) { e.preventDefault(); e.returnValue = ''; return ''; } }

    function splitList(attr) { return (inner.getAttribute(attr) || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
    var typeOptions = splitList('data-asub-type-options'); if (!typeOptions.length) typeOptions = ['Mockups', 'Mockup Sets', 'Freebies'];
    var licenseOptions = splitList('data-asub-license-options'); if (!licenseOptions.length) licenseOptions = ['Personal', 'Commercial', 'Extended Commercial'];
    var freeTypes = splitList('data-asub-free-types').map(function (s) { return s.toLowerCase(); });
    // Types that get the optional 3D model upload (the .glb viewer field). The
    // model slot is hidden for every other type (mockups etc).
    var modelTypes = splitList('data-asub-model-types').map(function (s) { return s.toLowerCase(); });
    if (!modelTypes.length) modelTypes = ['3d models', '3d model'];

    var els = {
      form: inner.querySelector('[data-asub-form]'),
      msg: inner.querySelector('[data-asub-msg]'),
      submit: inner.querySelector('[data-asub-submit]'),
      mfHost: inner.querySelector('[data-asub-metafields-host]'),
      consent: inner.querySelector('[data-asub-consent]'),
      typeHost: inner.querySelector('[data-asub-type-host]'),
      typeValue: inner.querySelector('[data-asub-type-value]'),
      licenses: inner.querySelector('[data-asub-licenses]'),
      freeNote: inner.querySelector('[data-asub-free-note]'),
      freeToggle: inner.querySelector('[data-asub-free-toggle]'),
      modelField: inner.querySelector('[data-asub-model-field]'),
      previewReq: inner.querySelector('[data-asub-preview-req]'),
    };

    // Custom-select instances for the 3D spec dropdowns (built once at init so
    // they match the form's other dropdowns instead of raw <select>s).
    var mxSel = {};

    function isFreeType(t) { return freeTypes.indexOf(String(t || '').toLowerCase()) !== -1; }
    function isModelType() { return modelTypes.indexOf(String(currentType()).toLowerCase()) !== -1; }
    // Show the 3D model upload only for 3D types; switching away hides it and
    // discards any staged model (so a non-3D product never carries one).
    function updateModelVisibility() {
      if (!els.modelField) return;
      var show = isModelType();
      // .asub-field has `display:flex`, which overrides the [hidden] attribute,
      // so toggle inline display (inline style wins) - this actually hides it.
      els.modelField.hidden = !show;
      els.modelField.style.display = show ? '' : 'none';
      // 3D products lead with the model, so previews are optional there.
      if (els.previewReq) {
        els.previewReq.textContent = show ? 'optional' : 'required';
        els.previewReq.className = show ? 'asub-opt' : 'asub-req';
        els.previewReq.setAttribute('data-asub-preview-req', '');
      }
      if (!show && typeof groups !== 'undefined' && groups.model && groups.model.length) {
        groups.model.slice().forEach(function (it) { removeItem('model', it); });
        renderThumbs('model');
      }
      // The viewer-toggle + spec block lives in the 3D zone too.
      var extras = inner.querySelector('[data-asub-model-extras]');
      if (extras) { extras.hidden = !show; extras.style.display = show ? '' : 'none'; }
      // The "Details" block is NOT hidden wholesale for 3D any more. 3D needs
      // Product Category from it - that metafield is what the store's smart
      // collections sort everything by - while File type, DPI and Layers belong
      // to mockups only. Which is which comes from the fourth column of the
      // Metafields setting, so it stays a setting rather than a rule in code.
      applyMetafieldScope();
    }

    // Build the spec dropdowns as the form's custom-select (so they look like
    // every other dropdown). Each host carries its options in data-asub-cs-opts.
    function buildModelExtraSelects() {
      inner.querySelectorAll('[data-asub-spec-cs]').forEach(function (host) {
        var name = host.getAttribute('data-asub-spec-cs');
        if (!name || mxSel[name]) return;
        var opts = [{ value: '', label: '—' }];
        (host.getAttribute('data-asub-cs-opts') || '').split('|').forEach(function (s) {
          s = s.trim(); if (s) opts.push({ value: s, label: s });
        });
        mxSel[name] = customSelect({ host: host, options: opts, value: '', placeholder: 'Select', searchable: false });
      });
    }

    // Read the curated 3D viewer toggles + spec inputs into the modelExtras shape
    // the server expects. File formats are a set of checkboxes joined to a string.
    function collectModelExtras() {
      var root = inner.querySelector('[data-asub-model-extras]');
      if (!root) return {};
      function cb(name) { var e = root.querySelector('[data-asub-mx="' + name + '"]'); return e ? !!e.checked : true; }
      // Dropdown values come from the custom-select api; the rest from inputs.
      function val(name) {
        if (mxSel[name]) return String(mxSel[name].getValue() || '').trim();
        var e = root.querySelector('[data-asub-spec="' + name + '"]'); return e ? String(e.value || '').trim() : '';
      }
      var formats = [];
      root.querySelectorAll('[data-asub-spec-format]').forEach(function (e) { if (e.checked) formats.push(e.value); });
      return {
        showWireframe: cb('showWireframe'),
        showUv: cb('showUv'),
        showShadow: cb('showShadow'),
        specs: {
          fileFormats: formats.join(', '),
          geometry: val('geometry'),
          polygons: val('polygons'),
          vertices: val('vertices'),
          uvMapped: val('uvMapped'),
          uvUnwrapped: val('uvUnwrapped'),
          materials: val('materials'),
          textures: val('textures'),
          pbr: val('pbr'),
          textureRes: val('textureRes'),
          rigged: val('rigged'),
          animated: val('animated'),
          realScale: val('realScale'),
          units: val('units'),
          nativeApp: val('nativeApp'),
          renderEngine: val('renderEngine'),
          gameReady: val('gameReady'),
          printReady: val('printReady')
        }
      };
    }
    function isFree() { return !!(els.freeToggle && els.freeToggle.checked); }

    // ---- Author config (standard pricing + self-publish), fetched on load ----
    var standardPrices = [];   // the list for the CURRENT type, [{name, price}]
    var canSelfPublish = false;
    var stdToggle = null;      // the "Use standard pricing" checkbox
    var stdWrap = null;        // its label wrapper (shown only for mockup types)
    var publishValue = '';     // '' | 'draft' | 'active' (self-publish only)
    var publishCs = null;      // the Visibility custom-select api
    var publishHintEl = null;  // the smart hint under it
    var editStatus = null;     // current submission status (edit mode), for the default
    function mapStatusToPublish(st) { return String(st || '').toLowerCase() === 'draft' ? 'draft' : 'active'; }
    function updatePublishHint() {
      if (!publishHintEl) return;
      publishHintEl.innerHTML = publishValue === 'draft'
        ? 'Saved as a <b>hidden draft</b> - it stays out of your store until you switch this to Active.'
        : 'Goes <b>live in your store immediately</b> - no moderation.';
    }
    function currentType() { return (els.typeValue && els.typeValue.value) || (typeOptions[0] || ''); }
    // The list for a type, matched case-insensitively so "3D Models" and
    // "3d models" are the same shelf.
    function pricesForType(t) {
      var lc = String(t || '').trim().toLowerCase();
      if (!lc) return [];
      var keys = Object.keys(standardPricesByType);
      for (var i = 0; i < keys.length; i++) {
        if (String(keys[i]).trim().toLowerCase() === lc) return standardPricesByType[keys[i]] || [];
      }
      return [];
    }
    function isStandardPriceType() { return pricesForType(currentType()).length > 0; }
    function stdPriceFor(name) {
      var lc = String(name || '').toLowerCase();
      for (var i = 0; i < standardPrices.length; i++) { if (String(standardPrices[i].name).toLowerCase() === lc) return standardPrices[i].price; }
      return null;
    }
    // Fill + lock the license inputs from the standard list when the checkbox is
    // on; unlock them when off. Re-applied after renderPricing rebuilds inputs.
    function applyStandard() {
      var on = !!(stdToggle && stdToggle.checked && isStandardPriceType() && !isFree());
      var rows = inner.querySelectorAll('[data-license]');
      for (var i = 0; i < rows.length; i++) {
        var input = rows[i];
        if (on) {
          var p = stdPriceFor(input.getAttribute('data-license'));
          if (p != null) { input.value = p; }
          input.readOnly = true; input.classList.add('asub-input--locked');
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          input.readOnly = false; input.classList.remove('asub-input--locked');
        }
      }
    }
    function updateStdVisibility() {
      // Re-point at the list for whatever type is selected now.
      standardPrices = pricesForType(currentType());
      if (!stdWrap) return;
      var show = isStandardPriceType() && !isFree() && standardPrices.length > 0;
      stdWrap.hidden = !show;
      if (!show && stdToggle) stdToggle.checked = false;
      applyStandard();
    }

    // ---- Type (custom select) ----
    var typeCs = null;
    if (els.typeHost) {
      typeCs = customSelect({
        host: els.typeHost,
        options: typeOptions.map(function (t) { return { value: t, label: t }; }),
        value: typeOptions[0] || '',
        placeholder: 'Select a type',
        searchable: false,
        onChange: function (v) {
          if (els.typeValue) els.typeValue.value = v;
          if (els.freeToggle) els.freeToggle.checked = isFreeType(v);
          renderPricing();
          updateStdVisibility();
          updateModelVisibility();
          markDirty();
        },
      });
      if (els.typeValue) els.typeValue.value = typeOptions[0] || '';
    }
    if (els.freeToggle) els.freeToggle.addEventListener('change', renderPricing);

    function renderPricing() {
      var free = isFree();
      if (els.freeNote) els.freeNote.hidden = !free;
      if (!els.licenses) return;
      if (free) { els.licenses.innerHTML = ''; els.licenses.hidden = true; return; }
      els.licenses.hidden = false;
      if (els.licenses.childElementCount !== licenseOptions.length) {
        els.licenses.innerHTML = '';
        licenseOptions.forEach(function (name) {
          var row = el('div', { className: 'asub-license-row' });
          row.appendChild(el('span', { className: 'asub-license-name', text: name }));
          var pw = el('div', { className: 'asub-license-price' });
          pw.appendChild(el('span', { className: 'asub-price-prefix', text: currencySymbol }));
          var priceInput = el('input', { className: 'asub-input', attrs: { type: 'number', min: '0', step: '0.01', placeholder: '0.00', 'data-license': name } });
          pw.appendChild(priceInput);
          enhanceNumber(priceInput);
          row.appendChild(pw); els.licenses.appendChild(row);
        });
      }
      if (stdToggle && stdToggle.checked) applyStandard();
    }
    function collectLicenses() {
      if (isFree()) return { ok: true, licenses: [{ name: freeVariantName, price: 0 }] };
      var rows = inner.querySelectorAll('[data-license]'); var out = [];
      for (var i = 0; i < rows.length; i++) {
        var name = rows[i].getAttribute('data-license'); var price = parseFloat(rows[i].value);
        if (isNaN(price) || price <= 0) return { ok: false, error: 'Please set a price for "' + name + '".' };
        out.push({ name: name, price: price });
      }
      if (!out.length) return { ok: false, error: 'No license prices to set.' };
      return { ok: true, licenses: out };
    }
    renderPricing();

    // Build the standard-pricing checkbox (mockups) + hydrate config; the
    // Draft/Active selector is added only for self-publish authors.
    (function setupAuthorConfig() {
      if (els.licenses && els.licenses.parentNode) {
        stdWrap = el('label', { className: 'asub-toggle asub-std-toggle' });
        stdWrap.hidden = true;
        stdToggle = el('input', { attrs: { type: 'checkbox' } });
        stdWrap.appendChild(stdToggle);
        stdWrap.appendChild(el('span', { text: 'Use standard pricing' }));
        els.licenses.parentNode.insertBefore(stdWrap, els.licenses);
        stdToggle.addEventListener('change', function () { applyStandard(); markDirty(); });
      }
      if (isPreview) return;
      fetch(CONFIG_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          standardPricesByType = (j && j.standardPricesByType && typeof j.standardPricesByType === 'object')
            ? j.standardPricesByType
            // An older app release only knew one list, and it was the mockup one.
            : ((j && Array.isArray(j.standardPrices) && j.standardPrices.length) ? { Mockups: j.standardPrices } : {});
          standardPrices = pricesForType(currentType());
          canSelfPublish = !!(j && j.canSelfPublish);
          updateStdVisibility();
          if (canSelfPublish) {
            buildPublishSelector();
            // No moderation -> the "sent back for review" note doesn't apply.
            var note = inner.querySelector('.asub-edit-note');
            if (note) note.hidden = true;
          }
        })
        .catch(function () {});
    })();

    function buildPublishSelector() {
      var host = inner.querySelector('.asub-col-side') || els.form || inner;
      var field = el('div', { className: 'asub-field asub-publish-field' });
      var label = el('label', { className: 'asub-label' });
      label.appendChild(el('span', { text: 'Visibility' }));
      label.appendChild(el('span', { className: 'asub-req', text: 'heads up' }));
      field.appendChild(label);
      var selHost = el('div');
      field.appendChild(selHost);
      publishHintEl = el('p', { className: 'asub-publish-hint' });
      field.appendChild(publishHintEl);
      host.appendChild(field);
      // In edit mode, default to the CURRENT status so a save doesn't silently
      // flip a live product to draft (or vice versa).
      publishValue = (isEdit && editStatus) ? mapStatusToPublish(editStatus) : 'active';
      publishCs = customSelect({
        host: selHost,
        options: [{ value: 'active', label: 'Active (publish now)' }, { value: 'draft', label: 'Draft (hidden)' }],
        value: publishValue, placeholder: 'Select', searchable: false,
        onChange: function (v) { publishValue = v; updatePublishHint(); markDirty(); },
      });
      updatePublishHint();
    }

    function setMsg(text, kind) { if (!els.msg) return; els.msg.textContent = text || ''; els.msg.className = 'asub-form-msg' + (kind ? ' is-' + kind : ''); }

    // A small animated SVG smiley, shown only after a clean submit ("all good").
    function injectSmiley() {
      if (!els.msg) return;
      var NS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'asub-smiley'); svg.setAttribute('viewBox', '0 0 48 48'); svg.setAttribute('aria-hidden', 'true');
      function s(tag, attrs) { var e = document.createElementNS(NS, tag); Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); }); return e; }
      svg.appendChild(s('circle', { 'class': 'sm-eye', cx: '18', cy: '19', r: '2.7' }));
      svg.appendChild(s('circle', { 'class': 'sm-eye sm-eye-r', cx: '30', cy: '19', r: '2.7' }));
      svg.appendChild(s('path', { 'class': 'sm-mouth', d: 'M14 27 Q24 39 34 27' }));
      els.msg.insertBefore(svg, els.msg.firstChild);
    }

    // ---- Files (two zones) ----
    // groups = newly added File objects; existing = refs already stored on the
    // submission (edit mode), kept unless the author removes them.
    var groups = { preview: [], sale: [], model: [] };
    var existing = { preview: [], sale: [], model: [] };

    // Cache one object URL per File so re-renders reuse the same blob instead of
    // re-creating it (that re-decode was the "thumbnails re-upload / flash" the
    // author saw while reordering). Revoked when a file is removed.
    var urlCache = [];
    function objUrl(file) {
      for (var i = 0; i < urlCache.length; i++) if (urlCache[i].file === file) return urlCache[i].url;
      var u = URL.createObjectURL(file);
      urlCache.push({ file: file, url: u });
      return u;
    }
    function revokeUrl(file) {
      for (var i = 0; i < urlCache.length; i++) {
        if (urlCache[i].file === file) { try { URL.revokeObjectURL(urlCache[i].url); } catch (e) {} urlCache.splice(i, 1); return; }
      }
    }

    // ---- Drag to reorder thumbnails (sets the gallery / file order) ----
    // Live reorder: the dragged node is physically moved among its siblings on
    // dragover (smooth, no flicker, no re-render mid-drag), and the arrays are
    // rebuilt from the final DOM order on dragend.
    //
    // ACROSS BOTH KINDS. It used to be existing-with-existing and new-with-new,
    // so a picture added during an edit could never be placed BEFORE one that
    // was already there - the author had to save, come back, and only then move
    // it. The gallery order now follows the tiles exactly, whatever mix of old
    // and new they are, and the order travels with the save.
    var dragEl = null, dragKind = null, dragZone = null;
    function attachDnD(t, zone, kind, host) {
      t.setAttribute('draggable', 'true');
      t.__kind = kind;
      t.addEventListener('dragstart', function (e) {
        dragEl = t; dragKind = kind; dragZone = zone;
        if (e.dataTransfer) { e.dataTransfer.effectAllowed = 'move'; try { e.dataTransfer.setData('text/plain', 'x'); } catch (_) {} }
        setTimeout(function () { t.classList.add('is-dragging'); }, 0);
      });
      t.addEventListener('dragover', function (e) {
        if (!dragEl || dragZone !== zone || t === dragEl) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
        var r = t.getBoundingClientRect();
        var before = e.clientX < r.left + r.width / 2;
        host.insertBefore(dragEl, before ? t : t.nextSibling);
      });
      t.addEventListener('dragend', function () {
        t.classList.remove('is-dragging');
        if (dragZone === zone) commitOrder(zone, host);
        dragEl = null; dragKind = null; dragZone = null;
      });
    }
    // The visible order, as one list. Each entry says which array it came from
    // so the two can be rebuilt, and `name` is what the server orders by.
    var viewOrder = { preview: [], sale: [], model: [] };

    function readOrder(zone, host) {
      var seq = [];
      Array.prototype.forEach.call(host.children, function (node) {
        if (!node.__item) return;
        var it = node.__item;
        seq.push({ kind: node.__kind, item: it, name: node.__kind === 'existing' ? it.filename : it.name });
      });
      return seq;
    }

    function commitOrder(zone, host) {
      var seq = readOrder(zone, host);
      var ex = seq.filter(function (x) { return x.kind === 'existing'; }).map(function (x) { return x.item; });
      var ng = seq.filter(function (x) { return x.kind === 'new'; }).map(function (x) { return x.item; });
      if (ex.length === existing[zone].length) existing[zone] = ex;
      if (ng.length === groups[zone].length) groups[zone] = ng;
      // Remember the MIXED order too: existing[] and groups[] alone cannot
      // express "new picture second, old picture third".
      viewOrder[zone] = seq.map(function (x) { return x.name; });
      renderThumbs(zone);
    }

    // Paint the circular upload progress on a thumb (conic-gradient ring).
    function setRing(item, frac) {
      var pct = Math.max(0, Math.min(100, Math.round((frac || 0) * 100)));
      if (item.ringEl) item.ringEl.style.background = 'conic-gradient(var(--asub-primary, #5A3E30) ' + (pct * 3.6) + 'deg, rgba(255,255,255,.35) 0)';
      if (item.pctEl) item.pctEl.textContent = pct + '%';
    }
    function updateThumbProgress(item) { setRing(item, item.progress); }

    // ALT TEXT, collected where the picture is.
    //
    // Only the author knows what their render shows, and only at the moment
    // they upload it; asking later, in the admin, means it never gets written.
    // Keyed by filename because that is what survives every route an image
    // takes to the product: raw bytes, a pre-uploaded id, or a file already
    // attached that an edit is keeping.
    var altByName = {};

    // A caption is a sentence, and a sentence does not fit under a 90px tile.
    // The tile carries a small ALT badge instead, and the writing happens in a
    // dialog with room to read what you typed.
    var altModal = null;

    function openAltDialog(name, onSave) {
      if (altModal) closeAltDialog();
      var overlay = el('div', { className: 'asub-altm' });
      // The dialog is appended to <body> so nothing can clip it, which also
      // puts it outside .asub-inner - where every --asub-* colour is declared.
      // Copy the resolved values across, or it would render in the fallback
      // palette and look like it belongs to another site.
      try {
        var cs = getComputedStyle(inner);
        [
          '--asub-bg', '--asub-card-bg', '--asub-text', '--asub-muted', '--asub-primary',
          '--asub-border', '--asub-radius', '--asub-stat-bg',
          '--asub-input-bg', '--asub-input-border', '--asub-input-text', '--asub-placeholder',
          '--asub-btn-bg', '--asub-btn-text', '--asub-btn-hover-bg', '--asub-btn-radius',
        ].forEach(function (v) {
          var val = cs.getPropertyValue(v);
          if (val && val.trim()) overlay.style.setProperty(v, val.trim());
        });
      } catch (e) {}
      var box = el('div', { className: 'asub-altm-box', attrs: { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Image description' } });
      box.appendChild(el('h3', { className: 'asub-altm-title', text: 'Describe this image' }));
      box.appendChild(el('p', {
        className: 'asub-altm-help',
        text: 'What a shopper would see. Read aloud by screen readers and used by search, so write it for a person: "Kraft mailer box on a concrete surface, three-quarter view".',
      }));
      var ta = el('textarea', {
        className: 'asub-input asub-textarea asub-altm-input',
        attrs: { rows: '3', maxlength: '512', placeholder: 'Kraft mailer box, three-quarter view' },
      });
      ta.value = altByName[name] || '';
      box.appendChild(ta);
      var count = el('p', { className: 'asub-altm-count' });
      function sync() { count.textContent = ta.value.length + ' of 512 characters'; }
      ta.addEventListener('input', sync); sync();
      box.appendChild(count);
      var row = el('div', { className: 'asub-altm-actions' });
      var cancel = el('button', { className: 'asub-btn asub-btn-ghost', text: 'Cancel', attrs: { type: 'button' } });
      var save = el('button', { className: 'asub-btn asub-btn-primary', text: 'Save description', attrs: { type: 'button' } });
      row.appendChild(cancel); row.appendChild(save);
      box.appendChild(row);
      overlay.appendChild(box);
      document.body.appendChild(overlay);
      altModal = overlay;

      function commit() {
        var v = (ta.value || '').trim();
        if (v) altByName[name] = v; else delete altByName[name];
        markDirty();
        closeAltDialog();
        if (onSave) onSave();
      }
      save.addEventListener('click', commit);
      cancel.addEventListener('click', closeAltDialog);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeAltDialog(); });
      // Enter saves, Escape leaves - the shortcuts a one-line answer wants.
      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeAltDialog(); }
        else if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); commit(); }
      });
      setTimeout(function () { try { ta.focus(); ta.select(); } catch (e) {} }, 0);
    }

    function closeAltDialog() {
      if (!altModal) return;
      try { altModal.parentNode.removeChild(altModal); } catch (e) {}
      altModal = null;
    }

    // The badge on the tile: says whether a description exists, opens the
    // dialog, and never starts a drag.
    function altBadge(zone, name) {
      if (zone !== 'preview') return null;
      var has = !!altByName[name];
      var b = el('button', {
        className: 'asub-thumb-altb' + (has ? ' has-alt' : ''),
        text: 'ALT',
        attrs: {
          type: 'button',
          title: has ? altByName[name] : 'Add an image description',
          'aria-label': (has ? 'Edit' : 'Add') + ' description for ' + (name || 'image'),
        },
      });
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        openAltDialog(name, function () { renderThumbs(zone); });
      });
      ['pointerdown', 'mousedown', 'dragstart'].forEach(function (ev) {
        b.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
      return b;
    }

    function renderThumbs(zone) {
      var host = inner.querySelector('[data-asub-thumbs="' + zone + '"]'); if (!host) return;
      host.innerHTML = '';
      // Existing (stored) files first.
      existing[zone].forEach(function (rf) {
        var t = el('div', { className: 'asub-thumb asub-thumb--existing' });
        t.__item = rf;
        if (rf.isImage && rf.url) { var im = document.createElement('img'); im.src = rf.url; im.loading = 'lazy'; im.draggable = false; t.appendChild(im); }
        else { t.appendChild(el('span', { className: 'asub-thumb-ext', text: ext(rf.filename) })); t.appendChild(el('span', { className: 'asub-thumb-file', text: (rf.filename || 'file').slice(0, 20) })); }
        // Download the already-stored file (edit mode).
        if (isEdit && editId && rf.id) {
          t.appendChild(el('a', { className: 'asub-thumb-dl', text: '↓', attrs: { href: DOWNLOAD_URL + '?submissionId=' + encodeURIComponent(editId) + '&b2FileId=' + encodeURIComponent(rf.id), target: '_blank', rel: 'noopener', title: 'Download', 'aria-label': 'Download' } }));
        }
        var xr = el('button', { className: 'asub-thumb-x', text: '×', attrs: { type: 'button', 'aria-label': 'Remove' } });
        xr.addEventListener('click', function () { var i = existing[zone].indexOf(rf); if (i !== -1) existing[zone].splice(i, 1); renderThumbs(zone); });
        t.appendChild(xr);
        attachDnD(t, zone, 'existing', host);
        // Seed from what the product already carries, once.
        if (rf.isImage && rf.alt && altByName[rf.filename] === undefined) altByName[rf.filename] = rf.alt;
        var abE = rf.isImage ? altBadge(zone, rf.filename) : null;
        if (abE) t.appendChild(abE);
        host.appendChild(t);
      });
      // Newly added files (each is an upload item with its own state).
      groups[zone].forEach(function (item) {
        var t = el('div', { className: 'asub-thumb asub-thumb--' + item.status });
        t.__item = item;
        if (IMG_RE.test(item.type)) { var img = document.createElement('img'); img.src = objUrl(item.file); img.decoding = 'async'; img.draggable = false; t.appendChild(img); }
        else { t.appendChild(el('span', { className: 'asub-thumb-ext', text: ext(item.name) })); t.appendChild(el('span', { className: 'asub-thumb-file', text: (item.name || 'file').slice(0, 20) })); }
        if (item.status === 'uploading') {
          var ov = el('div', { className: 'asub-thumb-prog' });
          var ring = el('div', { className: 'asub-thumb-ring' });
          var pct = el('span', { className: 'asub-thumb-pct' });
          ov.appendChild(ring); ov.appendChild(pct); t.appendChild(ov);
          item.ringEl = ring; item.pctEl = pct; setRing(item, item.progress);
        } else if (item.status === 'error') {
          t.appendChild(el('span', { className: 'asub-thumb-err', text: '!', attrs: { title: item.error || 'Upload failed' } }));
        } else if (item.status === 'done' && item.ref && item.ref.downloadHref) {
          t.appendChild(el('a', { className: 'asub-thumb-dl', text: '↓', attrs: { href: item.ref.downloadHref, target: '_blank', rel: 'noopener', title: 'Download', 'aria-label': 'Download' } }));
        }
        var x = el('button', { className: 'asub-thumb-x', text: '×', attrs: { type: 'button', 'aria-label': 'Remove' } });
        x.addEventListener('click', function () { removeItem(zone, item); });
        t.appendChild(x);
        attachDnD(t, zone, 'new', host);
        var abN = IMG_RE.test(item.type) ? altBadge(zone, item.name) : null;
        if (abN) t.appendChild(abN);
        host.appendChild(t);
      });
      // Re-apply a mixed order. The two arrays are painted existing-first, so
      // without this the tiles would snap back to that grouping after every
      // render and the author's arrangement would look like it did not take.
      var want = viewOrder[zone];
      if (want && want.length) {
        var byName = {};
        Array.prototype.forEach.call(host.children, function (node) {
          if (!node.__item) return;
          var nm = node.__kind === 'existing' ? node.__item.filename : node.__item.name;
          if (!(nm in byName)) byName[nm] = node;
        });
        want.forEach(function (nm) { var node = byName[nm]; if (node) host.appendChild(node); });
      }
      // Hint appears once there's more than one thumb to reorder.
      if ((existing[zone].length + groups[zone].length) > 1) {
        host.appendChild(el('span', { className: 'asub-thumbs-hint', text: 'Drag to reorder' }));
      }
    }

    // Stream one dropped file straight to B2 (with progress) before submit.
    function startUpload(zone, item) {
      var fd = new FormData();
      fd.append('file', item.file, item.name);
      var xhr = new XMLHttpRequest();
      item.xhr = xhr;
      xhr.open('POST', UPLOAD_URL + '?zone=' + (zone === 'preview' ? 'preview' : zone === 'model' ? 'model' : 'sale'), true);
      xhr.withCredentials = true;
      if (xhr.upload) xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) { item.progress = e.loaded / e.total; updateThumbProgress(item); }
      });
      xhr.addEventListener('load', function () {
        item.xhr = null;
        var json = null; try { json = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && json && json.ref) {
          item.status = 'done'; item.ref = json.ref; item.progress = 1; markDirty();
        } else {
          item.status = 'error'; item.error = (json && json.error) || 'Upload failed';
          setMsg('"' + item.name + '": ' + item.error, 'error');
        }
        renderThumbs(zone);
      });
      xhr.addEventListener('error', function () { item.xhr = null; item.status = 'error'; item.error = 'Network error'; renderThumbs(zone); });
      xhr.addEventListener('abort', function () { item.xhr = null; });
      xhr.send(fd);
    }
    // Delete a pre-uploaded file from B2 (non-multipart POST -> delete branch).
    function deleteUploadedRef(item) {
      if (!item.ref || !item.ref.id) return;
      try {
        fetch(UPLOAD_URL, {
          method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'op=delete&id=' + encodeURIComponent(item.ref.id),
        });
      } catch (e) {}
    }
    function removeItem(zone, item) {
      if (item.xhr) { try { item.xhr.abort(); } catch (e) {} }
      if (item.ref) deleteUploadedRef(item);
      var i = groups[zone].indexOf(item); if (i !== -1) groups[zone].splice(i, 1);
      revokeUrl(item.file);
      renderThumbs(zone);
    }
    function addFiles(zone, fileList) {
      var arr = Array.prototype.slice.call(fileList || []);
      // The 3D model slot holds exactly ONE model file - a new pick replaces the old.
      if (zone === 'model') {
        var mf = arr[0];
        if (!mf) return;
        if (!GLB_RE.test(mf.name)) { setMsg('The 3D model must be a .glb or .gltf file.', 'error'); return; }
        if (mf.size > MODEL_MAX) { setMsg('"' + mf.name + '" is over ' + Math.round(MODEL_MAX / 1048576) + 'MB.', 'error'); return; }
        groups.model.slice().forEach(function (it) { removeItem('model', it); });
        existing.model = [];
        var mitem = { file: mf, name: mf.name, size: mf.size, type: mf.type, status: 'uploading', progress: 0, ref: null, xhr: null, error: null };
        groups.model.push(mitem);
        startUpload('model', mitem);
        renderThumbs('model');
        markDirty();
        return;
      }
      for (var i = 0; i < arr.length; i++) {
        var f = arr[i];
        if (groups[zone].length >= MAX_FILES) { setMsg('Max ' + MAX_FILES + ' files per group.', 'error'); break; }
        var lim = zone === 'preview' ? PREVIEW_MAX : SALE_MAX;
        if (f.size > lim) { setMsg('"' + f.name + '" is over ' + Math.round(lim / 1048576) + 'MB.', 'error'); continue; }
        if (zone === 'preview' && !IMG_RE.test(f.type)) { setMsg('Previews must be images.', 'error'); continue; }
        if (groups[zone].some(function (s) { return s.name === f.name && s.size === f.size; })) continue;
        var item = { file: f, name: f.name, size: f.size, type: f.type, status: 'uploading', progress: 0, ref: null, xhr: null, error: null };
        groups[zone].push(item);
        startUpload(zone, item);
      }
      renderThumbs(zone);
    }
    ['preview', 'sale', 'model'].forEach(function (zone) {
      var fileInput = inner.querySelector('[data-asub-file="' + zone + '"]');
      var drop = inner.querySelector('[data-asub-drop="' + zone + '"]');
      if (fileInput) fileInput.addEventListener('change', function () { addFiles(zone, fileInput.files); fileInput.value = ''; });
      if (drop) {
        drop.setAttribute('role', 'button');
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-dragover'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-dragover'); }); });
        drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(zone, e.dataTransfer.files); });
        // Keyboard: Enter/Space opens the picker (a <label> alone doesn't).
        if (fileInput) drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
      }
    });
    // Build the spec dropdowns (custom-selects), then set initial 3D-model field
    // visibility (groups now exists), based on the default / current type.
    buildModelExtraSelects();
    updateModelVisibility();

    // ---- Tags (pills) ----
    var tags = [];
    var tagsEls = {
      wrap: inner.querySelector('[data-asub-tags]'),
      pills: inner.querySelector('[data-asub-tags-pills]'),
      input: inner.querySelector('[data-asub-tags-input]'),
      toggle: inner.querySelector('[data-asub-tags-toggle]'),
      value: inner.querySelector('[data-asub-tags-value]'),
    };
    var tagsExpanded = false;
    function renderTags() {
      if (!tagsEls.pills) return;
      tagsEls.pills.innerHTML = '';
      var show = tagsExpanded ? tags : tags.slice(0, TAGS_COLLAPSE_AT);
      show.forEach(function (t, idx) {
        var pill = el('span', { className: 'asub-pill' });
        pill.appendChild(el('span', { text: t }));
        var x = el('button', { className: 'asub-pill-x', text: '×', attrs: { type: 'button', 'aria-label': 'Remove tag' } });
        x.addEventListener('click', function () { tags.splice(tags.indexOf(t), 1); renderTags(); });
        pill.appendChild(x); tagsEls.pills.appendChild(pill);
      });
      if (tagsEls.toggle) {
        var hidden = tags.length - TAGS_COLLAPSE_AT;
        if (tags.length > TAGS_COLLAPSE_AT) { tagsEls.toggle.hidden = false; tagsEls.toggle.textContent = tagsExpanded ? 'Show less' : ('+' + hidden + ' more'); }
        else tagsEls.toggle.hidden = true;
      }
      if (tagsEls.value) tagsEls.value.value = tags.join(',');
    }
    function addTag(raw) {
      String(raw || '').split(',').forEach(function (t) {
        t = t.trim();
        if (t && tags.indexOf(t) === -1 && tags.length < 30) tags.push(t);
      });
      renderTags();
    }
    if (tagsEls.input) {
      tagsEls.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); addTag(tagsEls.input.value); tagsEls.input.value = ''; }
        else if (e.key === 'Backspace' && !tagsEls.input.value && tags.length) { tags.pop(); renderTags(); }
      });
      tagsEls.input.addEventListener('blur', function () { if (tagsEls.input.value.trim()) { addTag(tagsEls.input.value); tagsEls.input.value = ''; } });
    }
    if (tagsEls.toggle) tagsEls.toggle.addEventListener('click', function () { tagsExpanded = !tagsExpanded; renderTags(); });

    // ---- SEO collapsible + counters ----
    var seoToggle = inner.querySelector('[data-asub-seo-toggle]');
    var seoBody = inner.querySelector('[data-asub-seo-body]');
    if (seoToggle && seoBody) {
      seoToggle.addEventListener('click', function () {
        var open = seoBody.hidden;
        seoBody.hidden = !open;
        seoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        seoToggle.classList.toggle('is-open', open);
      });
    }
    ['seoTitle', 'seoDescription'].forEach(function (name) {
      var input = inner.querySelector('[name=' + name + ']');
      var counter = inner.querySelector('[data-asub-counter-for="' + name + '"]');
      if (!input || !counter) return;
      var max = input.getAttribute('maxlength') || '0';
      function upd() { counter.textContent = (input.value.length) + ' of ' + max + ' characters used'; }
      input.addEventListener('input', upd); upd();
    });

    // ---- Product metafields (fetch types + options, render widgets) ----
    var metafieldDefs = []; // { namespace, key, label, widget, cs?, node? }
    (function setupMetafields() {
      var raw = inner.getAttribute('data-asub-metafields') || '';
      var configured = [];
      raw.split(/\r?\n/).forEach(function (line) {
        var parts = line.split('|').map(function (s) { return s.trim(); });
        var nk = parts[0]; if (!nk || nk.indexOf('.') === -1) return;
        // Third column can inline a dropdown:
        //   select:Opt A,Opt B   ->  single-choice dropdown of those literals
        //   multiselect:A,B,C    ->  multi-choice dropdown
        // Otherwise the widget is auto-detected from the metafield definition.
        var inline = null;
        // `collections` (no colon) fills the dropdown from the SHOP'S OWN
        // collections instead of a hand-kept list. Shopify freezes a
        // metafield's choices the moment a smart collection reads it, so a list
        // maintained there is frozen the day it starts mattering. The
        // collections are the real list: a category exists because a collection
        // exists for it.
        var fromCollections = /^collections$/i.test((parts[2] || '').trim());
        var m = /^(select|multiselect)\s*:\s*(.+)$/i.exec(parts[2] || '');
        if (m) {
          inline = {
            widget: m[1].toLowerCase() === 'multiselect' ? 'multiselect' : 'select',
            options: m[2].split(',').map(function (s) { return s.trim(); }).filter(Boolean).map(function (s) { return { value: s, label: s }; }),
          };
        }
        // Fourth column scopes the field to product types:
        //   types:Mockups,Mockup Sets   -> only those
        //   skip:3D Models              -> everything except those
        // Absent = shown for every type. This is what lets one form serve both
        // mockups and 3D without a second copy of it.
        var only = null, skip = null;
        var sc = /^(types|skip)\s*:\s*(.+)$/i.exec(parts[3] || '');
        if (sc) {
          var list = sc[2].split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
          if (sc[1].toLowerCase() === 'types') only = list; else skip = list;
        }
        configured.push({ key: nk, label: parts[1] || '', inline: inline, fromCollections: fromCollections, only: only, skip: skip });
      });
      if (!configured.length || !els.mfHost) return;

      // Collection titles, as they came back from the same request.
      var shopCollections = [];

      function renderFromFields(fields) {
        // Index server field info by key.
        var info = {};
        (fields || []).forEach(function (f) { info[f.namespace + '.' + f.key] = f; });
        // Replace the server-rendered skeleton with the real widgets. Reset the
        // defs list so a cache->network re-render doesn't double up.
        metafieldDefs.length = 0;
        els.mfHost.innerHTML = '';
        els.mfHost.appendChild(el('div', { className: 'asub-mf-divider', text: 'Details' }));
        configured.forEach(function (cfg) {
          var dot = cfg.key.indexOf('.');
          var ns = cfg.key.slice(0, dot), key = cfg.key.slice(dot + 1);
          var f = info[cfg.key];
          var label = cfg.label || (f && f.name) || key;
          // Inline dropdown wins over server detection.
          var widget = cfg.inline ? cfg.inline.widget : (f ? f.widget : 'text');
          var options = cfg.inline ? cfg.inline.options : (f && f.options ? f.options : null);
          if (cfg.fromCollections) {
            widget = 'select';
            options = shopCollections.map(function (t) { return { value: t, label: t }; });
          }
          var entry = { namespace: ns, key: key, label: label, widget: widget, only: cfg.only, skip: cfg.skip, allOptions: options || null };

          if (widget === 'select' || widget === 'multiselect') {
            var field = el('div', { className: 'asub-field' });
            field.appendChild(el('label', { className: 'asub-label', text: label }));
            var host = el('div');
            field.appendChild(host); els.mfHost.appendChild(field);
            entry.field = field;
            entry.cs = customSelect({ host: host, options: options || [], multiple: widget === 'multiselect', placeholder: 'Select' + (widget === 'multiselect' ? ' (one or more)' : '') });
          } else if (widget === 'boolean') {
            var wrap = el('label', { className: 'asub-toggle asub-field' });
            entry.field = wrap;
            entry.node = el('input', { attrs: { type: 'checkbox' } });
            wrap.appendChild(entry.node); wrap.appendChild(el('span', { text: label }));
            els.mfHost.appendChild(wrap);
          } else {
            var fld = el('div', { className: 'asub-field' });
            entry.field = fld;
            fld.appendChild(el('label', { className: 'asub-label', text: label }));
            var isNum = (widget === 'number' || widget === 'integer');
            if (widget === 'textarea') entry.node = el('textarea', { className: 'asub-input asub-textarea', attrs: { rows: '3' } });
            else {
              var t = isNum ? 'number' : widget === 'date' ? 'date' : widget === 'url' ? 'url' : widget === 'color' ? 'color' : 'text';
              entry.node = el('input', { className: 'asub-input', attrs: { type: t, step: widget === 'integer' ? '1' : 'any' } });
            }
            fld.appendChild(entry.node); els.mfHost.appendChild(fld);
            if (isNum) enhanceNumber(entry.node);
          }
          metafieldDefs.push(entry);
        });
        if (afterMetafields) { try { afterMetafields(); } catch (e) {} }
        // After prefill, never before: narrowing the list first would throw away
        // a value the product already carries.
        applyMetafieldScope();
      }

      // Only ask the server about keys WITHOUT an inline dropdown (those need
      // their real type / metaobject options resolved). Inline ones render
      // straight from the section setting.
      var serverKeys = configured.filter(function (c) { return !c.inline; }).map(function (c) { return c.key; });
      if (isPreview || !serverKeys.length) { renderFromFields([]); return; }

      // Cache the resolved field info in localStorage keyed by the requested
      // keys. On repeat visits the real inputs render INSTANTLY from cache (no
      // waiting on the network), then we refresh in the background and only
      // re-render if the definition actually changed - so no second jolt.
      var cacheKey = 'asubMf:' + serverKeys.join(',');
      var cached = null;
      try { cached = localStorage.getItem(cacheKey); } catch (e) {}
      var rendered = false;
      if (cached) {
        try {
          var c = JSON.parse(cached);
          // Older caches held a bare array of fields.
          var cFields = Array.isArray(c) ? c : (c.fields || []);
          shopCollections = Array.isArray(c) ? [] : (c.collections || []);
          renderFromFields(cFields);
          rendered = true;
        } catch (e) {}
      }

      fetch('/apps/proxy/api/storefront/authors/metafield-options?keys=' + encodeURIComponent(serverKeys.join(',')), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var fields = j.fields || [];
          shopCollections = Array.isArray(j.collections) ? j.collections : [];
          // The collection list is part of what a field renders as, so it goes
          // in the cache key too - otherwise a newly created collection would
          // not appear until the browser cache expired.
          var serialized = JSON.stringify({ fields: fields, collections: shopCollections });
          try { if (cached !== serialized) localStorage.setItem(cacheKey, serialized); } catch (e) {}
          if (!rendered || serialized !== cached) renderFromFields(fields);
        })
        .catch(function () { if (!rendered) renderFromFields([]); });
    })();

    // Which "Details" fields belong to the product type currently chosen, and
    // which VALUES belong to it.
    //
    // The category list is shared by every type (Packaging Mockups, Box 3D
    // Models, ...), and the store's smart collections read it. Rather than
    // maintain a second mapping, the type is matched against the END of each
    // value: type "Mockup Sets" keeps "Packaging Mockup Sets" and drops
    // "Packaging Mockups"; type "3D Models" keeps "Box 3D Models". A type that
    // matches nothing (Freebies) keeps the full list, which is the safe answer.
    function applyMetafieldScope() {
      // The type switch runs BEFORE `var metafieldDefs = []` has executed, and a
      // hoisted var is `undefined` until then - calling .forEach on it threw and
      // took the whole init down with it, leaving the server-rendered skeleton
      // on screen with no widgets. There is also nothing to scope before the
      // fields exist, so leaving early is the correct answer either way.
      if (!els.mfHost || !metafieldDefs || !metafieldDefs.length) return;
      var lower = String(currentType() || '').trim().toLowerCase();
      var shown = 0;
      metafieldDefs.forEach(function (mf) {
        var ok = true;
        if (mf.only && mf.only.length) ok = mf.only.indexOf(lower) !== -1;
        else if (mf.skip && mf.skip.length) ok = mf.skip.indexOf(lower) === -1;
        mf.hidden = !ok;
        if (mf.field) { mf.field.hidden = !ok; mf.field.style.display = ok ? '' : 'none'; }
        if (!ok) return;
        shown++;
        if (!mf.cs || !mf.cs.setOptions || !mf.allOptions || !mf.allOptions.length || !lower) return;
        var fit = mf.allOptions.filter(function (o) {
          var v = String(o.value).trim().toLowerCase();
          return v.length > lower.length && v.slice(-lower.length) === lower;
        });
        var list = fit.length ? fit.slice() : mf.allOptions.slice();
        // Keep whatever the product already has, even if it sits outside the
        // narrowed list: an existing value is a fact, not a suggestion.
        var cur = mf.cs.getValue();
        var curVals = Array.isArray(cur) ? cur : (cur ? [cur] : []);
        curVals.forEach(function (v) {
          if (list.some(function (o) { return o.value === v; })) return;
          var found = mf.allOptions.filter(function (o) { return o.value === v; });
          if (found.length) list = found.concat(list);
        });
        mf.cs.setOptions(list);
      });
      var divider = els.mfHost.querySelector('.asub-mf-divider');
      if (divider) divider.style.display = shown ? '' : 'none';
      els.mfHost.style.display = shown ? '' : 'none';
    }

    function collectMetafields() {
      var out = [];
      metafieldDefs.forEach(function (mf) {
        if (mf.hidden) return;   // a field this type does not have
        var value = '';
        if (mf.widget === 'multiselect') { var arr = mf.cs.getValue(); if (!arr.length) return; value = JSON.stringify(arr); }
        else if (mf.widget === 'select') { value = mf.cs.getValue(); if (!value) return; }
        else if (mf.widget === 'boolean') { if (!mf.node.checked) return; value = 'true'; }
        else { value = (mf.node.value || '').trim(); if (!value) return; }
        out.push({ namespace: mf.namespace, key: mf.key, value: value, inputType: mf.widget });
      });
      return out;
    }

    // ---- Submit ----
    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (isPreview) { setMsg('Preview mode - submitting is disabled in the theme editor.', 'error'); return; }
        if (isEdit && !editId) { setMsg(NO_ID_MSG, 'error'); return; }
        var title = (els.form.querySelector('[name=title]') || {}).value || '';
        if (!title.trim()) { setMsg('Please enter a title.', 'error'); return; }
        // Files pre-upload in the background - don't submit until they finish.
        var stillUploading = groups.preview.concat(groups.sale).concat(groups.model).some(function (it) { return it.status === 'uploading'; });
        if (stillUploading) { setMsg('Please wait for your files to finish uploading.', 'error'); return; }
        var donePreviews = groups.preview.filter(function (it) { return it.status === 'done' && it.ref; });
        // 3D products require the model instead of previews; other types still
        // need at least one preview (it becomes the gallery).
        if (isModelType()) {
          var doneModel = groups.model.filter(function (it) { return it.status === 'done' && it.ref; });
          if (!doneModel.length && !existing.model.length) { setMsg('Please add a 3D model (.glb or .gltf).', 'error'); return; }
        } else if (!donePreviews.length && !existing.preview.length) {
          setMsg('Please add at least one preview image.', 'error'); return;
        }
        var lic = collectLicenses();
        if (!lic.ok) { setMsg(lic.error, 'error'); return; }
        // Required consent: must accept the platform terms to submit.
        if (els.consent && !els.consent.checked) {
          setMsg('Please accept the terms to continue.', 'error');
          els.consent.focus();
          return;
        }
        // Flush any half-typed tag.
        if (tagsEls.input && tagsEls.input.value.trim()) { addTag(tagsEls.input.value); tagsEls.input.value = ''; }

        var fd = new FormData();
        fd.append('title', title.trim());
        fd.append('description', (els.form.querySelector('[name=description]') || {}).value || '');
        fd.append('productType', (els.typeValue && els.typeValue.value) || '');
        fd.append('tags', tags.join(','));
        fd.append('currency', currency);
        fd.append('licenseOptionName', licenseOptionName);
        fd.append('licenses', JSON.stringify(lic.licenses));
        fd.append('productCategory', inner.getAttribute('data-asub-product-category') || '');
        fd.append('seoTitle', (els.form.querySelector('[name=seoTitle]') || {}).value || '');
        fd.append('seoDescription', (els.form.querySelector('[name=seoDescription]') || {}).value || '');
        // Alt text, keyed by filename. Sent for kept images too, so an author
        // can caption a picture that is already on the product.
        try { fd.append('previewAlts', JSON.stringify(altByName)); } catch (e) {}
        // The gallery order the author actually arranged, by filename - the one
        // name a picture keeps whether it is being kept or newly uploaded.
        try {
          var pvHost = inner.querySelector('[data-asub-thumbs="preview"]');
          var order = pvHost ? readOrder('preview', pvHost).map(function (x) { return x.name; }) : (viewOrder.preview || []);
          if (order.length) fd.append('previewOrder', JSON.stringify(order));
        } catch (e) {}
        fd.append('metafields', JSON.stringify(collectMetafields()));
        if (isEdit) {
          fd.append('submissionId', editId);
          fd.append('keepFileIds', JSON.stringify(existing.preview.concat(existing.sale).concat(isModelType() ? existing.model : []).map(function (r) { return r.id; })));
        }
        // Files already streamed to B2 - send their pending-upload ids only.
        fd.append('previewIds', JSON.stringify(groups.preview.filter(function (it) { return it.status === 'done' && it.ref; }).map(function (it) { return it.ref.id; })));
        fd.append('deliverableIds', JSON.stringify(groups.sale.filter(function (it) { return it.status === 'done' && it.ref; }).map(function (it) { return it.ref.id; })));
        fd.append('modelIds', JSON.stringify(isModelType() ? groups.model.filter(function (it) { return it.status === 'done' && it.ref; }).map(function (it) { return it.ref.id; }) : []));
        // Curated 3D viewer toggles + spec fields (only for 3D types).
        fd.append('modelExtras', JSON.stringify(isModelType() ? collectModelExtras() : {}));
        // Self-publish authors: Draft/Active choice (ignored server-side for others).
        if (canSelfPublish && publishValue) fd.append('publishMode', publishValue);

        els.submit.disabled = true; els.submit.classList.add('is-loading');
        setMsg(isEdit ? 'Saving your changes...' : 'Creating your draft...', '');
        function onProg(frac) {
          var pct = Math.round(frac * 100);
          if (pct >= 100) setMsg('Finishing up...', '');
        }
        xhrUpload(SUBMIT_URL, fd, onProg)
          .then(function (resp) {
            els.submit.disabled = false; els.submit.classList.remove('is-loading');
            if (!resp.ok) { setMsg((resp.json && resp.json.error) || (isEdit ? 'Could not save.' : 'Submission failed.'), 'error'); return; }
            // Success - the form is no longer "dirty", so the unload guard
            // won't block the redirect.
            dirty = false;
            var projects = inner.getAttribute('data-asub-projects-url');
            var warns = (resp.json && resp.json.warnings) || [];
            var respMode = (resp.json && resp.json.mode) || 'review';
            if (warns.length) { try { console.warn('[asub] submission warnings:', warns); } catch (e) {} }
            // Smart success message per outcome (publish live / draft / review).
            var okMsg;
            if (warns.length) {
              okMsg = (isEdit ? 'Saved. ' : 'Submitted. ') + 'Note: ' + warns[0];
            } else if (respMode === 'active') {
              okMsg = isEdit ? 'Saved - your changes are live in your store.' : 'Published! Your work is now live in your store.';
            } else if (respMode === 'draft') {
              okMsg = 'Saved as a draft - hidden from your store until you publish it.';
            } else {
              okMsg = isEdit ? 'Saved! Your changes were sent back for review.' : 'Submitted! Your work is now pending review.';
            }
            setMsg(okMsg, warns.length ? 'error' : 'success');
            if (!warns.length) injectSmiley();
            if (isEdit) {
              // Refresh from server so a second save doesn't re-send consumed ids.
              refreshEditFromServer();
            } else {
              els.form.reset(); groups.preview = []; groups.sale = []; groups.model = []; tags = [];
              renderThumbs('preview'); renderThumbs('sale'); renderThumbs('model'); renderTags();
              if (els.consent) els.consent.checked = false;
            }
            // Move focus to the status message for screen-reader users.
            if (els.msg) { els.msg.setAttribute('tabindex', '-1'); try { els.msg.focus(); } catch (e) {} }
            // Redirect to projects only on a clean submit; if there were
            // warnings, keep the author here so they can read them.
            if (projects && !warns.length) setTimeout(function () { window.location.href = projects; }, 1200);
          })
          .catch(function (err) {
            els.submit.disabled = false; els.submit.classList.remove('is-loading');
            setMsg((isEdit ? 'Save failed: ' : 'Submission failed: ') + err.message, 'error');
          });
      });
    }

    // ---- Edit mode: prefill the form from the existing submission ----
    function applyMetafieldValues(values) {
      metafieldDefs.forEach(function (mf) {
        var match = null;
        for (var i = 0; i < values.length; i++) { if (values[i].namespace === mf.namespace && values[i].key === mf.key) { match = values[i]; break; } }
        if (!match) return;
        if (mf.widget === 'multiselect') {
          var arr; try { arr = JSON.parse(match.value); } catch (e) { arr = String(match.value).split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
          if (mf.cs) mf.cs.setValue(Array.isArray(arr) ? arr : []);
        } else if (mf.widget === 'select') {
          if (mf.cs) mf.cs.setValue(match.value);
        } else if (mf.widget === 'boolean') {
          if (mf.node) mf.node.checked = /^(true|1|yes|on)$/i.test(String(match.value));
        } else {
          if (mf.node) mf.node.value = match.value;
        }
      });
    }

    function applyEditData(d) {
      // Remember the current status so the Visibility selector defaults to it
      // (whether it was built before or after this prefill).
      editStatus = d.status || null;
      if (canSelfPublish && publishCs) { publishValue = mapStatusToPublish(editStatus); publishCs.setValue(publishValue); updatePublishHint(); }
      var titleInput = els.form && els.form.querySelector('[name=title]');
      if (titleInput) titleInput.value = d.title || '';
      var descInput = els.form && els.form.querySelector('[name=description]');
      if (descInput) descInput.value = d.description || '';

      // Type + free toggle + license prices.
      if (typeCs && d.productType) { typeCs.setValue(d.productType); if (els.typeValue) els.typeValue.value = d.productType; }
      if (els.freeToggle) els.freeToggle.checked = !!d.isFree;
      renderPricing();
      if (!d.isFree && Array.isArray(d.licenses)) {
        d.licenses.forEach(function (l) {
          var input = inner.querySelector('[data-license="' + (l.name || '').replace(/"/g, '\\"') + '"]');
          if (input) { input.value = (l.price != null ? l.price : ''); input.dispatchEvent(new Event('input', { bubbles: true })); }
        });
      }

      // Tags.
      if (Array.isArray(d.tags)) { tags = d.tags.slice(); renderTags(); }

      // SEO (open the panel if there's content).
      var seoTitleInput = inner.querySelector('[name=seoTitle]');
      var seoDescInput = inner.querySelector('[name=seoDescription]');
      if (seoTitleInput) { seoTitleInput.value = d.seoTitle || ''; seoTitleInput.dispatchEvent(new Event('input', { bubbles: true })); }
      if (seoDescInput) { seoDescInput.value = d.seoDescription || ''; seoDescInput.dispatchEvent(new Event('input', { bubbles: true })); }
      if ((d.seoTitle || d.seoDescription) && seoBody && seoBody.hidden && seoToggle) { seoToggle.click(); }

      // Existing files as removable thumbs. Clear any in-progress NEW items too,
      // so refreshing after a save can't leave stale (already-consumed) uploads
      // in `groups` - re-sending their ids on a second save would drop them.
      groups.preview = []; groups.sale = []; groups.model = [];
      existing.preview = Array.isArray(d.previewFiles) ? d.previewFiles.slice() : [];
      existing.sale = Array.isArray(d.deliverableFiles) ? d.deliverableFiles.slice() : [];
      existing.model = Array.isArray(d.modelFiles) ? d.modelFiles.slice() : [];
      renderThumbs('preview'); renderThumbs('sale'); renderThumbs('model');
      // Match the model field to the edited product's type.
      updateModelVisibility();

      // Prefill the 3D viewer toggles + spec fields. Toggles default to ON when
      // the submission predates this feature (modelExtras absent).
      (function () {
        var root = inner.querySelector('[data-asub-model-extras]');
        if (!root) return;
        var mx = d.modelExtras || null;
        function setCb(name, v) { var e = root.querySelector('[data-asub-mx="' + name + '"]'); if (e) e.checked = (v !== false); }
        function setVal(name, v) {
          if (mxSel[name]) { mxSel[name].setValue(v == null ? '' : String(v)); return; }
          var e = root.querySelector('[data-asub-spec="' + name + '"]'); if (e) e.value = (v == null ? '' : String(v));
        }
        setCb('showWireframe', mx ? mx.showWireframe : true);
        setCb('showUv', mx ? mx.showUv : true);
        // `!== false`, not truthiness: a submission made before this field
        // existed has no value at all, and "did not say" means the default.
        setCb('showShadow', mx ? mx.showShadow !== false : true);
        var sp = (mx && mx.specs) ? mx.specs : {};
        setVal('geometry', sp.geometry); setVal('polygons', sp.polygons); setVal('vertices', sp.vertices);
        setVal('uvMapped', sp.uvMapped); setVal('uvUnwrapped', sp.uvUnwrapped);
        setVal('materials', sp.materials); setVal('textures', sp.textures);
        setVal('pbr', sp.pbr); setVal('textureRes', sp.textureRes);
        setVal('rigged', sp.rigged); setVal('animated', sp.animated);
        setVal('realScale', sp.realScale); setVal('units', sp.units);
        setVal('nativeApp', sp.nativeApp); setVal('renderEngine', sp.renderEngine);
        setVal('gameReady', sp.gameReady); setVal('printReady', sp.printReady);
        var fmts = String(sp.fileFormats || '').split(',').map(function (s) { return s.trim().toLowerCase(); });
        root.querySelectorAll('[data-asub-spec-format]').forEach(function (e) { e.checked = fmts.indexOf(String(e.value).toLowerCase()) !== -1; });
      })();

      // Metafields render async - apply now if ready, else hook for later.
      var mfVals = Array.isArray(d.metafields) ? d.metafields : [];
      afterMetafields = function () { applyMetafieldValues(mfVals); };
      if (metafieldDefs.length) afterMetafields();
    }

    // Re-pull the saved submission after an edit save, so `existing` reflects
    // the freshly-stored files and `groups` is cleared (prevents a second save
    // from re-sending now-consumed ids and silently dropping files).
    function refreshEditFromServer() {
      if (!isEdit || !editId || isPreview) return;
      fetch(EDIT_URL + '?id=' + encodeURIComponent(editId), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.submission) { applyEditData(j.submission); dirty = false; } })
        .catch(function () {});
    }

    // Nothing to edit, so say so NOW. Before this, the form sat there looking
    // perfectly usable, the author filled the whole thing in, pressed the
    // button, and only then found out the page could never have saved it.
    if (isEdit && !editId && !isPreview) {
      setMsg(NO_ID_MSG, 'error');
      if (els.submit) { els.submit.disabled = true; }
      if (els.form) { els.form.setAttribute('aria-disabled', 'true'); }
    }

    if (isEdit && editId && !isPreview) {
      setMsg('Loading your project...', '');
      fetch(EDIT_URL + '?id=' + encodeURIComponent(editId), { credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          if (!resp.ok || !resp.json || !resp.json.submission) { setMsg((resp.json && resp.json.error) || 'Could not load this project.', 'error'); return; }
          applyEditData(resp.json.submission);
          setMsg('', '');
          // Track changes only AFTER prefill, so the programmatic fill above
          // doesn't trip the unsaved-changes guard.
          dirty = false;
          els.form.addEventListener('input', markDirty);
          els.form.addEventListener('change', markDirty);
          window.addEventListener('beforeunload', beforeUnloadHandler);
        })
        .catch(function (err) { setMsg('Could not load this project: ' + err.message, 'error'); });
    }
  }

  function boot() {
    document.querySelectorAll('.asub-wrapper').forEach(function (root) {
      if (root.dataset.asubInit === '1') return;
      root.dataset.asubInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
